export const transformShippingInstructionsCarrierDto = shippingInstructionsCarrier => ({
  name: shippingInstructionsCarrier.name,
  iconUrl: shippingInstructionsCarrier.icon_url
});
export const transformShippingInstructionsDto = shippingInstructions => ({
  id: shippingInstructions.id,
  carrier: transformShippingInstructionsCarrierDto(shippingInstructions.carrier),
  instructions: shippingInstructions.instructions
});